import { inject, injectable } from "inversify";

import Capacity from "@model/Capacity";
import CapacityForm from "@vm/Form/Capacity";
import AssociatedEditViewModel from "@vm/Edit/AssociatedEditViewModel";
import TYPES from "../../inversify.types";
import { action } from "mobx";
import WorkingTimeRatiosListVM from "@vm/List/WorkingTimeRatios";

// There is error in babel
// remove this after https://github.com/babel/babel/issues/9838
// will be fixed
void TYPES;
void inject;

@injectable()
export default class CapacityEditVM extends AssociatedEditViewModel<Capacity, AssociatedRepository<Capacity>> {
  constructor(
    @inject(TYPES.CapacityRepository) repository: AssociatedRepository<Capacity>,
    @inject(TYPES.CapacityForm) public capacityFormVM: CapacityForm,
    @inject(TYPES.WorkingTimeRatiosList) public workingTimeRatiosListVM: WorkingTimeRatiosListVM
  ) {
    super(Capacity, repository);
  }

  setParentId(parentId: number) {
    super.setParentId(parentId);

    this.capacityFormVM.setParentId(parentId);
  }

  get allowedToSave(): boolean {
    return this.capacityFormVM.allowedToSave;
  }

  setEntity(entity: Capacity) {
    super.setEntity(entity);
    this.capacityFormVM.setEntity(entity);
  }

  @action
  resetEntityAndErrors() {
    super.resetEntityAndErrors();
    // Keep next line for reseting entity for Capacity,
    this.entity = new Capacity();
    this.capacityFormVM.setEntity(this.entity);
  }
}
